import React from 'react';
import './terms-conditions.css';
import Navbar from '../Menus/Navbar';
import Footer from '../Menus/Footer';

export default function TermsConditions() {
  return (
    <>
      <Navbar />
      <section id="terms-section">
        <div className="terms-container">
          <h1 className="terms-title">Terms and Conditions</h1>
          <p className="terms-intro">
            Welcome to <strong>Home Appliance Assist</strong>. These terms and conditions outline the rules and regulations for the use of our website and services. By accessing this website, we assume you accept these terms and conditions in full.
          </p>

          <div className="terms-content">
            <div id="term-1">
              <h3>1. Acceptance of Terms</h3>
              <p>By using our services, you agree to be bound by these Terms and Conditions. If you do not agree to any part of these terms, please discontinue use of our services.</p>
            </div>

            <div id="term-2">
              <h3>2. Service Scope</h3>
              <p>Our services are intended for personal use only. Commercial use of our services is prohibited unless explicitly authorized by us.</p>
            </div>

            <div id="term-3">
              <h3>3. Personal Information Collection</h3>
              <p>We collect personal information, including your name, address, and phone number, solely for the purpose of following up and informing you about the next service. Your data is securely maintained in a Google Sheet.</p>
            </div>

            <div id="term-4">
              <h3>4. Data Privacy</h3>
              <p>We do not share, sell, or disclose your personal information to third parties. We are committed to maintaining your privacy and trust.</p>
            </div>

            <div id="term-5">
              <h3>5. Service Availability</h3>
              <p>We aim to provide uninterrupted access to our services; however, we do not guarantee that services will be available at all times.</p>
            </div>

            <div id="term-6">
              <h3>6. Service Modifications</h3>
              <p>We reserve the right to modify, suspend, or discontinue any part of our services at any time without notice.</p>
            </div>

            <div id="term-7">
              <h3>7. Payment Terms</h3>
              <p>Payments for services must be made in accordance with the terms agreed upon at the time of service. Failure to comply may result in service termination.</p>
            </div>

            <div id="term-8">
              <h3>8. Intellectual Property Rights</h3>
              <p>All content, including text, images, and trademarks on our website, is owned by Home Appliance Assist and is protected by intellectual property laws. Unauthorized use of our content is prohibited.</p>
            </div>

            <div id="term-9">
              <h3>9. Limitation of Liability</h3>
              <p>Home Appliance Assist is not liable for any direct, indirect, incidental, or consequential damages arising from the use of our services.</p>
            </div>

            <div id="term-10">
              <h3>10. Governing Law</h3>
              <p>These Terms and Conditions are governed by and construed in accordance with the laws of the jurisdiction in which we operate.</p>
            </div>

            <div id="term-11">
              <h3>11. Amendments</h3>
              <p>We reserve the right to update these Terms and Conditions at any time. Continued use of our services following any changes indicates your acceptance of the new terms.</p>
            </div>

            <div id="term-12">
              <h3>12. Termination of Service</h3>
              <p>We reserve the right to terminate your access to our services for any violation of these Terms and Conditions or for any other reason at our discretion.</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
